/* eslint-disable ember/classic-decorator-no-classic-methods, ember/no-computed-properties-in-native-classes */
import Controller from '@ember/controller';
import { action, computed } from '@ember/object';

export default class MyFeedController extends Controller {
  queryParams = ['offset'];
  offset = 0;

  @computed('model.feed.@each.isRead')
  get readPostIds() {
    return this.model.feed
      .filter((entry) => entry.isRead)
      .map((entry) => entry.entityId);
  }

  @action
  nextPage() {
    this.incrementProperty('offset', 20);
  }

  @action
  prevPage() {
    this.decrementProperty('offset', 20);
  }
}
